import React from "react"
import { StatementData as data } from "../../data"

export const Statement = () => {
    return (
        <section className="statement" id="statement" >
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="section-heading">
                            <h2>Этапы работы</h2>
                        </div>
                        <div className="row">
                            <div className="statement-items col-lg-7   ">
                                <div className="title">
                                    <h3>Как мы работаем</h3>
                                    <span>Описание процесса, как мы взаимодействуем с клиентом для достижения наилучшего результата</span>
                                </div>
                                
                                {
                                    data.map((statement, idx) => {
                                        return (
                                            <div
                                                className="statement-col"
                                                key={statement.sequence ?? idx}
                                            >
                                                <article className='statement-item'>
                                                    <div className="statement-item-header">
                                                        <span className="statement-item-badge" aria-hidden="true">{statement.sequence}</span>
                                                        <h3 id={`stmt-${idx}-title`} className="statement-item-title">{statement.title}</h3>
                                                    </div>
                                                    <p className="statement-item-desc">{statement.description}</p>
                                                </article>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className="col-lg-5">
                                <img src="/assets/images/steps_of_work.png" alt="Этапы работы" />
                            </div>
                            
                        </div>
                    </div>
                </div>
            </div>
        </section >
    )
}